import { ESensorModel, EHiveModel } from '@/types';

export const SENSOR_MODELS: ESensorModel[] = [
  ESensorModel.HEATIC3,
  ESensorModel.HEATIC2_PLUS,
  ESensorModel.HEATIC2,
  ESensorModel.HEATIC1,
  ESensorModel.UNKNOWN,
];

export const HIVE_MODELS: EHiveModel[] = [
  EHiveModel.HIVE3,
  EHiveModel.HIVE2,
  EHiveModel.HIVE1C_PLUS,
  EHiveModel.HIVE1C,
  EHiveModel.HIVE1,
  EHiveModel.UNKNOWN,
];
